import { render } from "./Categorias.vue?vue&type=template&id=3a6e4c12"
import script from "./Categorias.vue?vue&type=script&lang=js"
export * from "./Categorias.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__